module.exports = __webpack_public_path__ + "img/pethouse38.bbb4bfa5.jpg";